const resolvePreferredGender = (genderPreferences) => (genderPreferences ? [`gender:(${genderPreferences.map((g) => `"${g}"`).join(' ')})`] : []);

export default resolvePreferredGender;
